// i18n.setup.js
import store from '@/store/store'
import getLocaleFromUrl from '@ui/shared-utils/src/getLocaleFromUrl'
import getSitesData from '@ui/shared-utils/src/getSites'
import { isSSOEnabled } from '@/config/get-features'

export async function initialiseStore () {
  const { pseudoLocale, urlPrefix, additionalHeaders } = getLocaleFromUrl()
  const sites = await getSitesData(urlPrefix, pseudoLocale, additionalHeaders)
  sites.useGoogleSSO = isSSOEnabled(additionalHeaders.country)

  // initialise store
  store.dispatch(
    'site/initialise',
    { sites, pseudoLocale }
  )
}
